module.exports = __webpack_public_path__ + "assets/img/WechatIMG58.01cc0ee1.png";